import React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export type CalendarIconProps = SvgIconProps

export function CalendarIcon(props: CalendarIconProps) {
  return (
    <SvgIcon width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 0.5C3.44772 0.5 3 0.947715 3 1.5V2.5H2C0.895431 2.5 0 3.39543 0 4.5V14.5C0 15.6046 0.895431 16.5 2 16.5H14C15.1046 16.5 16 15.6046 16 14.5V4.5C16 3.39543 15.1046 2.5 14 2.5H13V1.5C13 0.947715 12.5523 0.5 12 0.5C11.4477 0.5 11 0.947715 11 1.5V2.5H5V1.5C5 0.947715 4.55228 0.5 4 0.5ZM4 5.5C3.44772 5.5 3 5.94772 3 6.5C3 7.05228 3.44772 7.5 4 7.5H12C12.5523 7.5 13 7.05228 13 6.5C13 5.94772 12.5523 5.5 12 5.5H4Z"
        fill="#9CA3AF"
      />
    </SvgIcon>
  )
}

export default CalendarIcon